main.map = (function () {
    var mapElement;
    var map;
    var geocodedLocations = {};

    var mapOptions = {
        zoom: 16,
        scrollwheel: false,
        draggable: true,
        mapTypeControlOptions: { mapTypeIds: [] }
    };

    var init = function() {
        mapElement = document.getElementById('map-canvas');

        if (mapElement) {
            if (typeof google === 'undefined') {
                main.utils.loadScript('//maps.googleapis.com/maps/api/js?v=3.exp&' +
                    '&key=AIzaSyB6kVfvsPLuNUqygQ2-3tX3w965Wqjtiek&callback=main.map.initMap');
            } else {
                main.map.initMap();
            }
        }
    };

    var initMap = function() {
        _getLocations();
    };

    var _getLocations = function() {
        var request = new XMLHttpRequest();
        var url = '/locations.json?lang=' + document.documentElement.lang;
        request.open('GET', url, true);

        request.onload = function() {
            if (request.status >= 200 && request.status < 400) {
                var response = JSON.parse(request.responseText);
                _geoCodeLocations(response.data[0].locations);
            } else {
            }
        };

        request.onerror = function() {
        };

        request.send();
    };

    var _geoCodeLocations = function(locations) {
        var geocoder = new google.maps.Geocoder();
        var bounds = new google.maps.LatLngBounds();
        var markerImage = {
            url: window.location.origin + '/assets/images/marker.svg',
            size: new google.maps.Size(26, 39),
            scaledSize: new google.maps.Size(26, 39),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(13, 39),
            optimized: false,
        };
        var locationCount = locations.length;
        var geocodedCount = 0;

        geocodedLocations = locations;

        for (var i = 0, length = locations.length; i < length; i++){
            var location = locations[i];

            _geocode(location);
        }

        map = new google.maps.Map(mapElement, mapOptions);

        function _geocode(location) {
            geocoder.geocode({ 'address' : location.address }, function(results, status) {
                if ( status == google.maps.GeocoderStatus.OK ) {
                    var latlng = results[0].geometry.location;
                    var marker = new google.maps.Marker({
                        position: latlng,
                        map: map,
                        icon: markerImage,
                    });

                    bounds.extend(latlng);
                    geocodedLocations[geocodedCount].position = latlng;
                } else {
                    console.log( 'Geocode was not successful for the following reason: ' + status );
                }

                geocodedCount++;

                // Geocode is asynchronous
                // So we check here if all locations are geocoded
                // Otherwise fitBounds() won't work
                if (geocodedCount === locationCount) {
                    map.fitBounds(bounds);
                    _setMapHandlers();
                }
            });
        }
    };

    var _setMapHandlers = function() {
        var triggers = document.getElementsByClassName('js-map-control');

        if (!triggers) {
            return;
        }

        for (var i = 0, length1 = triggers.length; i < length1; i++){
            triggers[i].addEventListener('click', _clickHandler);
        }

        function _clickHandler(event) {
            var locationId = event.currentTarget.dataset.id;
            var clickedLocation = geocodedLocations.find(function(item) {
                return item.id === locationId;
            });

            map.setZoom(11);
            map.panTo(clickedLocation.position);
        }
    };

    return {
        init: init,
        initMap: initMap
    };
})();
